import { put, takeLatest, delay } from "redux-saga/effects";
import { cancelDeleteAccountApi } from "store/api/LoginApi";
import { CANCEL_DELETE_ACCOUNT_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* cancelDeleteAccount(action) {
	yield put(globalAction.openLoadingPage());
	const { onSuccess } = action.params;
	const res = yield cancelDeleteAccountApi();
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* cancelDeleteAccountSaga() {
	yield takeLatest(CANCEL_DELETE_ACCOUNT_ACTION, cancelDeleteAccount);
}

export default cancelDeleteAccountSaga;
